export const stepOption = [
    {


        value: "1", title: "Выявление новых случаев", type: "input", level: 1,
        data: [26795.00,   27046.00,   29158.00,   34443.00,   35540.00,   34955.00,   36725.00,   38245.00,   40986.00,   33707.00],
        dataPredictor: 1281,
        cr: `${process.env.PUBLIC_URL}/images/pdf/cr/KR12.pdf`
    },
    {
        value: "s1", title: "Стадия I", typex: "stage", col: 0.5, level: 2,
        data: [2385.00,   2578.00,   2869.00,   3758.00,   4321.00,   4582.00,   5143.00,   5595.00,   6268.00,   5505.00], dataPredictor: 436
    },
    {
        value: "s2", title: "Стадия II", typex: "stage", col: 1.5, level: 2,
        data: [10979.00,   11237.00,   12494.00,   15383.00,   16653.00,   16482.00,   17557.00,   18732.00,   20412.00,   16929.00], dataPredictor: 941,
    },
    {
        value: "s3", title: "Стадия III", typex: "stage", col: 2.5, level: 2,
        data: [9192.00,   9073.00,   9603.00,   10583.00,   10420.00,   9452.00,   9502.00,   8954.00,   9265.00,   6655.00], dataPredictor: 15
    },
    {
        value: "s4", title: "Стадия IV", typex: "stage", col: 3.5, level: 2,
        fixed: "toTable",
        data: [4868.00,   5079.00,   5340.00,   6032.00,   6055.00,   6551.00,   7222.00,   7869.00,   8362.00,   7618.00], dataPredictor: 390
    },

    {value: "p1", title: "Подлежат наблюдению", col: 1, level: 3},

    {value: "p2", title: "Подлежат лечению", col: 2, level: 4},

    {value: "mq1", title: "Не мРПЖ", col: 1, level: 5},
    {value: "mq2", title: "мРПЖ", col: 3, level: 5},

    {value: "mq3", title: "Кастрационно-чувствительный", col: 2, level: 6},

    {value: "t1", title: "Хирургическая кастрация", col: 1, level: 7},
    {value: "t2", title: "Агонисты ЛГРГ", col: 2, level: 7},
    {value: "t3", title: "Антагонисты ЛГРГ", col: 3, level: 7},
/*
    {value: "mq", title: "Кастрационно-чувствительный", col: 2, level: 5},

    {value: "m1", title: "Цисплатин +", col: 1, level: 6},
    {value: "m2", title: "Цисплатин -", col: 3, level: 6},
*/

    {
        value: "h2", title: "Большой объем МТС", typex: "treat", col: 2, level: 9,
        // getCont: {c1: 0.6}
    },
    {
        value: "h1", title: "Хирургическая кастрация, дожитие", typex: "treat", col: 1, level: 9,
        // getCont: {c1: 0.8}
    },
    {
        value: "h3", title: "НЕ большой объем МТС", typex: "treat", col: 3, level: 9,
        // getCont: {c1: 0.65}
    },

]
export const stepConnection = [
    {source: "1", target: "s1", label: "", generator: "S1"},
    {source: "1", target: "s2", label: "", generator: "S2"},
    {source: "1", target: "s3", label: "", generator: "S3"},
    {source: "1", target: "s4", label: "", generator: "S4"},

    {source: "s1", target: "p1", label: "25%", sender: {value: "0.82", ttl: "1"}, mutator: {name: "M1", task: ["sender", "value"]}},
    {source: "s2", target: "p1", label: "30%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "M2", task: ["sender", "value"]}},
    {source: "s3", target: "p1", label: "30%", sender: {value: "0.41", ttl: "1"}, mutator: {name: "M3", task: ["sender", "value"]}},
    {source: "s4", target: "p1", label: "30%", sender: {value: "0.21", ttl: "1"}, mutator: {name: "M4", task: ["sender", "value"]}},

    {source: "s1", target: "p2", label: "25%", sender: {value: "0.82", ttl: "1"}, mutator: {name: "MN1", task: ["sender", "value"]}},
    {source: "s2", target: "p2", label: "30%", sender: {value: "0.65", ttl: "1"}, mutator: {name: "MN2", task: ["sender", "value"]}},
    {source: "s3", target: "p2", label: "30%", sender: {value: "0.41", ttl: "1"}, mutator: {name: "MN3", task: ["sender", "value"]}},
    {source: "s4", target: "p2", label: "30%", sender: {value: "0.21", ttl: "1"}, mutator: {name: "MN4", task: ["sender", "value"]}},

    {source: "p1", target: "p2", label: "Не эффективно", sender: {value: "0.325", ttl: "1"}},
    {source: "p2", target: "mq1", label: "Не эффективно", sender: {value: "0.718", ttl: "1"}},
    {source: "p2", target: "mq2", label: "Не эффективно", sender: {value: "0.281", ttl: "1"}},

    {source: "mq2", target: "mq3", label: "Не эффективно", sender: {value: "0.53", ttl: "1"}},


    {source: "mq3", target: "t1", label: "Не эффективно", sender: {value: "0.41", ttl: "1"}},
    {source: "mq3", target: "t2", label: "Не эффективно", sender: {value: "0.25", ttl: "1"}},
    {source: "mq3", target: "t3", label: "Не эффективно", sender: {value: "0.34", ttl: "1"}},

    {source: "t1", target: "h1", label: "Не эффективно", sender: {value: "1", ttl: "1"}},

    {source: "t2", target: "h2", label: "Не эффективно", sender: {value: "0.53", ttl: "1"}},
    {source: "t3", target: "h2", label: "Не эффективно", sender: {value: "0.53", ttl: "1"}},

    {source: "t2", target: "h3", label: "Не эффективно", sender: {value: "0.47", ttl: "1"}},
    {source: "t3", target: "h3", label: "Не эффективно", sender: {value: "0.47", ttl: "1"}},

    /*
    {source: "p1", target: "p2", label: "Не эффективно", sender: {value: "0.35", ttl: "1"}},

    {source: "p1", target: "t1", label: "100%", sender: {value: "0.25", ttl: "1"}},
    {source: "s4", target: "t1", label: "80%", sender: {value: "0.30", ttl: "0"}},

    {source: "t1", target: "mq", label: "", sender: {value: "0.30", ttl: "0"}},


    {source: "mq", target: "m1", label: "68%", sender: {value: "0.68", ttl: "0"}},
    {source: "mq", target: "m2", label: "32%", sender: {value: "0.32", ttl: "0"}},

    {source: "m1", target: "p2", sender: {value: "0.43", ttl: "0"}},

    {source: "m2", target: "m3", label: "43%", sender: {value: "0.68", ttl: "0"}},
    {source: "m2", target: "m4", label: "57%", sender: {value: "0.32", ttl: "0"}},

    {source: "p2", target: "h1", sender: {value: "0.32", ttl: "0"}},
    {source: "m3", target: "h2", sender: {value: "1", ttl: "0"}},
    {source: "m4", target: "p3", sender: {value: "0.32", ttl: "0"}},
    {source: "p3", target: "h3", sender: {value: "1", ttl: "0"}}
    */

]
export const modeling = [
    {
        value: "h1x", source: "h1", title: "Хирургическая кастрация, дожитие", selector: 'H1', kmv:
            {
                A: [0.8, 0.6],
                B: [0.8, 0.6]
            },
    },
    {
        value: "h2x", source: "h2", title: "Терапия А, дожитие", selector: 'H2', kmv:
            {
                A: [0.78, 0.67],
                B: [0.8, 0.7]
            },
    },
    {
        value: "h3x", source: "h3", title: "Терапия Б, дожитие", selector: 'H3', kmv:
            {
                A: [0.74, 0.63],
                B: [0.8, 0.723]
            },
    },
]
export const data = [
    {
        name: '2014',
        s1: 4000,
        s2: 2400,
        s3: 2400,
        s4: 1500,
    },
    {
        name: '2016',
        s1: 3000,
        s2: 1398,
        s3: 2210,
        s4: 5280,
    },
    {
        name: '2016',
        s1: 2000,
        s2: 9800,
        s3: 2290,
        s4: 2016,
    },
    {
        name: '2017',
        s1: 2780,
        s2: 3908,
        s3: 2000,
        s4: 1500,
    },
    {
        name: '2018',
        s1: 1890,
        s2: 4800,
        s3: 2181,
        s4: 3181,
    },
    {
        name: '2019',
        s1: 2390,
        s2: 3800,
        s3: 2500,
        s4: 2000,
    },
    {
        name: '2020',
        s1: 3490,
        s2: 4300,
        s3: 2100,
        s4: 1281,
    },
];

export const mainTrends = {
    stageI_II: {
        data: [64.57,  66.86,  69.11,  69.63,  71.25,  72.79,  74.16,  74.97,  76.25,  78.03,  77.32],
        ltr: 0.21
    },
    live5y: {
        data: [47.66,  48.89,  48.90,  49.42,  49.97,  50.27,  51.92,  52.53,  52.74,  54.66,  55.84],
        ltr: 0.76
    },
    live1y: {
        data: [21.31,  19.47,  18.93,  17.93,  17.47,  16.53,  16.55,  14.91,  14.45,  14.27,  14.01],
        ltr: -0.71
    },
    dnl: {
        data: [49,        50,     51,     52,    53,      54,     55, 56,      57,   58,    59],
        ltr: 1

    },


    live1yttl: {
        data: [27.38, 26.09, 25.32, 24.77, 23.58, 23.25, 22.51, 22.25, 21.68, 20.60],
        ltr: -0.69
    },
    live5yttl: {
        data: [51.34,	51.07,	51.67,	52.43,	52.92,	53.34,	53.94,	54.45,	55.33,	56.57],
        ltr: 0.58
    },

}

const Model = {
    stepOption, stepConnection, mainTrends, data, modeling,
    defaultStrategy: {
        H1A: '0', H2A: '0', H3A: '0',
        H1B: '10', H2B: '20', H3B: '40',
        M1: '81',
        M2: '64',
        M3: '41',
        M4: '15',
        MN1: '8',
        MN2: '15',
        MN3: '45',
        MN4: '77',

    },
    name: "Рак предстательной железы",
    options: {
        showTrends: true,
        mainView: {
            title: "Выявление по стадиям",
            lines: [
                {key: "s1", title: "I стадия"},
                {key: "s2", title: "II стадия"},
                {key: "s3", title: "III стадия"},
                {key: "s4", title: "IV стадия"},
            ]
        }
    },
    vars: {
        strategy: [
            //{title: "Доля направленных на Атезолизумаб после прогрессирование на Цисплатине, %", prefix: "H1"},
            {title: "Доля целевой терапии (с мтс), %", prefix: "H2"},
            {title: "Доля целевой терапии (без мтс), %", prefix: "H3"},
        ],
        mutation: [
            {title: "Подлежат наблюдению  I стадии, %", prefix: "M1"},
            {title: "Подлежат наблюдению  II стадии, %", prefix: "M2"},
            {title: "Подлежат наблюдению  III стадии, %", prefix: "M3"},
            {title: "Подлежат наблюдению  IV стадии, %", prefix: "M4"},
            {title: "Подлежат лечению  I стадии, %", prefix: "MN1"},
            {title: "Подлежат лечению  II стадии, %", prefix: "MN2"},
            {title: "Подлежат лечению  III стадии, %", prefix: "MN3"},
            {title: "Подлежат лечению  IV стадии, %", prefix: "MN4"},
        ]
    },
}

export default Model